import {
  AnalysisIcon,
  DocumentIcon,
  InformationIcon,
  SparklesIcon,
  TaskIcon,
  getIconComponent as getIconComponentFromMapping,
} from "@storytell/bsky-icons";
import type { Block, StreamingBlock } from "@storytell/streaming";
import { BlockRenderer } from "@storytell/streaming";
import type { Component, JSX } from "solid-js";
import { Dynamic } from "solid-js/web";

const VARIANT_CLASSES = {
  blue: "text-blue-600 dark:text-blue-400",
  purple: "text-purple-600 dark:text-purple-400",
  green: "text-green-600 dark:text-green-400",
  gray: "text-gray-600 dark:text-gray-400",
} as const;

interface IconConfig {
  size?: number;
  variant?: keyof typeof VARIANT_CLASSES;
}

const icons: Record<BlockRenderer, Component> = {
  [BlockRenderer.USER_FACING_MESSAGE]: SparklesIcon,
  [BlockRenderer.ARTIFACT_VIEWER]: DocumentIcon,
  [BlockRenderer.TASK_CARD]: TaskIcon,
  [BlockRenderer.BLOCK_PREVIEW]: InformationIcon,
  [BlockRenderer.INTERSTITIAL]: InformationIcon,
  [BlockRenderer.PROMPT_ACK]: InformationIcon,
  [BlockRenderer.INTERSTITIAL_DATA]: InformationIcon,
  [BlockRenderer.INTERSTITIAL_CATCH]: InformationIcon,
  [BlockRenderer.INTERSTITIAL_USER_FACING]: InformationIcon,
  [BlockRenderer.TURN_COMPLETE]: InformationIcon,
  [BlockRenderer.UNKNOWN]: InformationIcon,
};

export const getBlockIconComponent = (
  block: StreamingBlock,
  preferredRenderer: BlockRenderer,
  config: IconConfig = {},
): JSX.Element => {
  const { size = 16, variant = "blue" } = config;

  // Use block's specific icon if available
  // TODO: @andi add back in
  // if (block.icon) {
  //   return <Dynamic component={getIconComponentFromMapping(block.icon)} size={size} class={VARIANT_CLASSES[variant]} />;
  // }

  let rendererIcon = InformationIcon;
  const preferredIcon = icons[preferredRenderer];
  if (preferredIcon) {
    rendererIcon = preferredIcon;
  }

  // const rendererColor =
  //   {
  //     [BlockRenderer.ARTIFACT_VIEWER]: "green",
  //     [BlockRenderer.TASK_CARD]: "purple",
  //   }[block.preferredRenderer] || variant;

  const IconComponent = rendererIcon;
  return <IconComponent size={size} class={"purple"} />;
};
